import React, { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate, NavLink } from 'react-router-dom';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Agents from './pages/Agents';
import Accounts from './pages/Accounts';
import Conversations from './pages/Conversations';
import Scripts from './pages/Scripts';
import KnowledgeBases from './pages/KnowledgeBases';
import Proxies from './pages/Proxies';
import Campaigns from './pages/Campaigns';
import SentContacts from './pages/SentContacts';
import CheckContacts from './pages/CheckContacts';
import Team from './pages/Team';
import Blacklist from './pages/Blacklist';
import Settings from './pages/Settings';
import api from './api/client';

function Layout({ children, user }) {
  const isOwner = !user || user.role === 'owner';

  const ownerNav = [
    { to: '/', icon: '⊞', label: 'Обзор' },
    { to: '/conversations', icon: '💬', label: 'Диалоги' },
    { to: '/campaigns', icon: '📣', label: 'Рассылки' },
    { to: '/agents', icon: '🤖', label: 'Агенты' },
    { to: '/accounts', icon: '✈️', label: 'Аккаунты' },
    { to: '/proxies', icon: '🔒', label: 'Прокси' },
    { to: '/scripts', icon: '📝', label: 'Скрипты' },
    { to: '/knowledge', icon: '📚', label: 'База знаний' },
    { to: '/sent-contacts', icon: '📋', label: 'База контактов' },
    { to: '/check-contacts', icon: '🔍', label: 'Проверка базы' },
    { to: '/team', icon: '👥', label: 'Команда' },
    { to: '/blacklist', icon: '🚫', label: 'Чёрный список' },
  ];

  const managerNav = [
    { to: '/conversations', icon: '💬', label: 'Диалоги' },
  ];

  const nav = isOwner ? ownerNav : managerNav;

  return (
    <div style={{ display: 'flex', height: '100vh', fontFamily: 'system-ui,sans-serif', background: '#f8f8f7' }}>
      <aside style={{ width: 220, background: '#fff', borderRight: '1px solid #e8e8e6', display: 'flex', flexDirection: 'column' }}>
        <div style={{ padding: '20px 16px 12px', fontWeight: 600, fontSize: 16, borderBottom: '1px solid #e8e8e6' }}>
          🤖 AgentDesk
        </div>
        {user && (
          <div style={{ padding: '8px 16px', borderBottom: '1px solid #e8e8e6', fontSize: 12, color: '#888' }}>
            {user.name || user.email}
            {user.role === 'manager' && <span style={{ marginLeft: 6, background: '#f0effe', color: '#534AB7', padding: '1px 6px', borderRadius: 8 }}>менеджер</span>}
          </div>
        )}
        <nav style={{ padding: 8, flex: 1, overflowY: 'auto' }}>
          {nav.map(n => (
            <NavLink key={n.to} to={n.to} end={n.to === '/'} style={({ isActive }) => ({
              display: 'flex', alignItems: 'center', gap: 10, padding: '8px 10px', borderRadius: 8,
              textDecoration: 'none', fontSize: 14, marginBottom: 2,
              background: isActive ? '#f0effe' : 'transparent',
              color: isActive ? '#534AB7' : '#555', fontWeight: isActive ? 500 : 400,
            })}><span>{n.icon}</span>{n.label}</NavLink>
          ))}
        </nav>
        <div style={{ padding: '8px', borderTop: '1px solid #e8e8e6' }}>
          <NavLink to="/settings" style={({ isActive }) => ({
            display: 'flex', alignItems: 'center', gap: 10, padding: '8px 10px', borderRadius: 8,
            textDecoration: 'none', fontSize: 14, marginBottom: 4,
            background: isActive ? '#f0effe' : 'transparent',
            color: isActive ? '#534AB7' : '#555',
          })}>⚙️ Настройки</NavLink>
          <button onClick={() => { localStorage.removeItem('token'); window.location.href = '/login'; }}
            style={{ width: '100%', padding: '7px 0', border: '1px solid #e8e8e6', borderRadius: 8, background: 'none', cursor: 'pointer', fontSize: 13, color: '#888' }}>
            Выйти
          </button>
        </div>
      </aside>
      <main style={{ flex: 1, overflow: 'auto' }}>{children}</main>
    </div>
  );
}

function PrivateRoute({ children, setUser }) {
  const [ok, setOk] = useState(null);
  const [user, setUserState] = useState(null);
  useEffect(() => {
    api.get('/auth/me')
      .then(r => { setOk(true); setUserState(r.data); setUser(r.data); })
      .catch(() => setOk(false));
  }, []);
  if (ok === null) return <div style={{ padding: 40, color: '#999' }}>Загрузка...</div>;
  return ok ? React.cloneElement(children, { user }) : <Navigate to="/login" />;
}

export default function App() {
  const [user, setUser] = useState(null);
  const isOwner = !user || user.role === 'owner';

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/*" element={
          <PrivateRoute setUser={setUser}>
            <Layout user={user}>
              <Routes>
                {isOwner && <Route path="/" element={<Dashboard />} />}
                <Route path="/conversations" element={<Conversations />} />
                <Route path="/settings" element={<Settings />} />
                {isOwner && <>
                  <Route path="/campaigns" element={<Campaigns />} />
                  <Route path="/sent-contacts" element={<SentContacts />} />
                  <Route path="/check-contacts" element={<CheckContacts />} />
                  <Route path="/agents" element={<Agents />} />
                  <Route path="/accounts" element={<Accounts />} />
                  <Route path="/proxies" element={<Proxies />} />
                  <Route path="/scripts" element={<Scripts />} />
                  <Route path="/knowledge" element={<KnowledgeBases />} />
                  <Route path="/team" element={<Team />} />
                  <Route path="/blacklist" element={<Blacklist />} />
                </>}
                <Route path="*" element={<Navigate to={isOwner ? "/" : "/conversations"} />} />
              </Routes>
            </Layout>
          </PrivateRoute>
        } />
      </Routes>
    </BrowserRouter>
  );
}
